import Header from "@/components/Header";
import Hero from "@/components/Hero";
import DataBar from "@/components/DataBar";
import HowItWorksNew from "@/components/HowItWorksNew";
import ProductFeatures from "@/components/ProductFeatures";
import FeaturedDeals from "@/components/FeaturedDeals";
import PricingTeaser from "@/components/PricingTeaser";
import FaqSection from "@/components/FaqSection";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <DataBar />
        <HowItWorksNew />
        <ProductFeatures />
        <FeaturedDeals />
        <PricingTeaser />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
